import { render, staticRenderFns } from "./reportError.vue?vue&type=template&id=4bf0262f&scoped=true&"
import script from "./reportError.vue?vue&type=script&lang=js&"
export * from "./reportError.vue?vue&type=script&lang=js&"
import style0 from "./reportError.vue?vue&type=style&index=0&id=4bf0262f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0262f",
  null
  
)

export default component.exports